/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["quote-start .quote-start{display:flex;flex:1}quote-start .big-circle{border-radius:50%;width:240px;height:240px;line-height:240px;text-align:center;border:1px solid;background-color:#ffff}@media screen and (max-width:959px){quote-start .big-circle{width:160px;height:160px;line-height:160px}}quote-start .app-title{font-weight:600;font-size:32px}quote-start .secondary-text{font-size:16px}"];
export { styles as styles };
